import { BASE_CLASS_PREFIX } from '../base/constants';

const cssClasses = {
    PREFIX: `${BASE_CLASS_PREFIX }-descriptions`,
};

const strings = {
    ALIGN_SET: ['left', 'justify', 'plain', 'center'],
    SIZE_SET: ['small', 'medium', 'large'],
    LAYOUT_SET: ['horizontal', 'vertical']
};

const numbers = {};

export {
    cssClasses,
    strings,
    numbers
};